import { formatLocalDateDisplay } from "./dateUtils";

const WHATSAPP_TARGET_NUMBER = "19999787030";

const normalizeHour = (hour) => {
  if (!hour) return "";

  if (Array.isArray(hour) && hour.length > 0) {
    return hour[0];
  }

  return hour;
};

export const buildCancellationWhatsappLink = (appointment) => {
  if (!appointment) return null;

  const {
    name = "",
    date = "",
    hour = "",
    service = "",
    professional = "",
    tid = "",
  } = appointment;

  const formattedHour = normalizeHour(hour);
  const formattedDate = formatLocalDateDisplay(date);
  const upperName = name ? name.toUpperCase() : "";

  const messageLines = [
    `Olá, sou o ${upperName} e confirmo o cancelamento do meu agendamento com os seguintes dados:`,
    "",
    `Data: *${formattedDate}*`,
    `Horário: *${formattedHour}*`,
    `Barbeiro: *${professional}*`,
    `Serviço: *${service}*`,
    `ID do agendamento: *${tid}*`,
    "",
    "_ENVIE ESSA MENSAGEM PARA CONFIRMAR SEU CANCELAMENTO_",
  ];

  const encodedMessage = encodeURIComponent(messageLines.join("\n"));

  return `https://wa.me/${WHATSAPP_TARGET_NUMBER}?text=${encodedMessage}`;
};
